<!-- 行业展会 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 title="行业展会" label="INFORMARION" :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="infoBlock3" count="10" v-on:queryPage="hyzh_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="热门展会" label="HOT SERVICE":showMore="false" count="3" :infoBlock="infoBlock1" :infoPage="infoPage1" moreLink="/hyzx05" v-on:queryPage="rmzh_Req"/>
        <infoList title="推荐资讯" label="FAST NEWS" :showTitle="true" :showMore="false" :infoBlock="infoBlock12" :infoPage="infoPage2" v-on:queryPage="zxkx_Req" titleLength="30" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import InfoBlock03 from '../block/InfoBlock03'
import HyzhImgInfo from '../module/HyzhImgInfo'
import InfoList from '../block/InfoList'
import InfoBlock12 from '../block/InfoBlock12'
export default {
  name: 'Hyzx05',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList':InfoList,
  },
  data() {
    return {
      msg: '',
      infoBlock1:HyzhImgInfo,
      infoPage:{},
      infoPage1:{page:{},list:[]},
      infoBlock3:InfoBlock03,

      infoPage2:{},
      infoBlock12:InfoBlock12,
    }
  },
  methods:{
    //行业展会
    hyzh_Req(params){
          let that=this;
          let result={page:params};
          //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.expoList(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //热门展会
    rmzh_Req(params){
      //params.type='policy_library';
      let that=this;
      let result={page:params};
      //params={page:1,pageSize:7,recommend_id:3};
      //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.recommendLists(params).then(res =>{
          that.msg=res.msg;
          //that.tabList=res.data.list;
          //that.tabList=[];
          result.list= res.data.expo;
          result.page.total=3;

          that.infoPage1=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
        });

    },
    //最新快讯
    zxkx_Req(params){
          var date = new Date();
          let that=this;
          params.queryYear=date.getFullYear();
          params.queryMonth=date.getMonth()+1;
          if(this.Global.siteTabId>0){params.tag_id=this.Global.siteTabId;}
          let result={page:params};
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.fastNewsLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage2=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
  created:function(){
    let params={page:1,pageSize:10};
    this.hyzh_Req(params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Hyzx05.vue